import Nav from '../Nav/Nav';
import Footer from '../Footer/Footer';
import './Muvtech.css';
import MuvtechHero from './MuvtechHero';
import MuvtechFancy from './MuvtechFancy';

const MuvtechHome = () => {
  return (
    <div style={{ overflow: 'hidden' }}>
      <Nav />
      <div className="muvtech-wrapper">
        <section id="muvtech">
          <MuvtechHero />
        </section>
      </div>
      <MuvtechFancy />
      <Footer />
    </div>
  );
};

export default MuvtechHome;
